import Search from './search'
import { APIClient } from '@/infrastructure/network/Zipcloud/APIClient'

export default class ZipcloudGateway {
  apiClient: APIClient
  Search: Search

  constructor(apiClient: APIClient) {
    this.apiClient = apiClient
    this.Search = new Search(apiClient)
  }
}
